import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, withModifiers as _withModifiers, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-da726a52"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "StepCarFTL" }
const _hoisted_2 = {
  key: 0,
  class: "StepCarFTL__title"
}
const _hoisted_3 = {
  key: 1,
  class: "flex items-center justify-between"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "StepCarFTL__title" }, "Машина", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times mr-2" }, null, -1))
const _hoisted_6 = { class: "StepCarFTL__grid" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "flex flex-col mt-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "font-semibold text-gray-500 select-none" }, " Способ оплаты за доставку ", -1))
const _hoisted_10 = { class: "flex flex-col mt-2" }
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "mt-3 flex items-center justify-end" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))
const _hoisted_14 = {
  key: 1,
  class: "mt-3"
}
const _hoisted_15 = { class: "grid grid-cols-2 gap-3" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold select-none" }, "Кубатура машины", -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("sup", null, "3", -1))
const _hoisted_19 = { key: 1 }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold select-none" }, " Грузоподъёмность машины ", -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold select-none" }, "Описание", -1))
const _hoisted_22 = { key: 2 }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold select-none" }, "Тип транспорта", -1))
const _hoisted_24 = { key: 3 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold select-none" }, "Тип погрузки", -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold select-none" }, "Температурный режим", -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold select-none" }, "Объявленная стоимость", -1))
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold select-none" }, "Негабарит", -1))
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold select-none" }, "Опасный груз", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-gray-400 font-semibold select-none" }, "Штабелируемый груз", -1))
const _hoisted_31 = { class: "text-gray-400 font-semibold select-none" }
const _hoisted_32 = { class: "flex items-center justify-end" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-pen mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!
  const _component_radio_group = _resolveComponent("radio-group")!
  const _component_checkbox = _resolveComponent("checkbox")!
  const _component_file_reader = _resolveComponent("file-reader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.isCompleted)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, _toDisplayString(_ctx.stepNumber) + ". Оформите машину", 1))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _hoisted_4,
          _createVNode(_component_the_button, {
            class: "second text small",
            disabled: _ctx.disabled,
            onClick: _ctx.resetForm
          }, {
            default: _withCtx(() => [
              _hoisted_5,
              _createTextVNode(" Сбросить ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"])
        ])),
    (_ctx.opened)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
          (!_ctx.isCompleted || !_ctx.isOnCargoStep)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                class: "mt-3",
                onSubmit: _cache[16] || (_cache[16] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.emitSubmit && _ctx.emitSubmit(...args)), ["prevent"]))
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", _hoisted_7, [
                    (_ctx.isAuto)
                      ? (_openBlock(), _createBlock(_component_the_select, {
                          key: 0,
                          class: "mt-3",
                          value: _ctx.state.load_capacity,
                          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.load_capacity) = $event)),
                          "is-invalid": _ctx.state_form$.load_capacity.$error,
                          "validation-errors": _ctx.state_form$.load_capacity.$errors,
                          options: _ctx.capacity_state.list,
                          loading: _ctx.capacity_state.is_loading,
                          searchable: false,
                          label: "load_capacity",
                          selectBy: "load_capacity",
                          placeholder: "Грузоподъёмность машины",
                          onChange: _ctx.onCapacityChange,
                          disabled: _ctx.state.is_need_car
                        }, null, 8, ["value", "is-invalid", "validation-errors", "options", "loading", "onChange", "disabled"]))
                      : _createCommentVNode("", true),
                    (_ctx.isAuto)
                      ? (_openBlock(), _createBlock(_component_the_select, {
                          key: 1,
                          class: "mt-3",
                          value: _ctx.state.cubature,
                          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.cubature) = $event)),
                          "is-invalid": _ctx.state_form$.cubature.$error,
                          "validation-errors": _ctx.state_form$.cubature.$errors,
                          options: _ctx.capacity_state.list,
                          loading: _ctx.capacity_state.is_loading,
                          searchable: false,
                          label: "cubature",
                          selectBy: "cubature",
                          placeholder: "Кубатура машины",
                          disabled: _ctx.state.is_need_car
                        }, null, 8, ["value", "is-invalid", "validation-errors", "options", "loading", "disabled"]))
                      : _createCommentVNode("", true),
                    (_ctx.isAuto)
                      ? (_openBlock(), _createBlock(_component_the_select, {
                          key: 2,
                          class: "mt-3",
                          value: _ctx.state.loading_type,
                          "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.loading_type) = $event)),
                          "is-invalid": _ctx.state_form$.loading_type.$error,
                          "validation-errors": _ctx.state_form$.loading_type.$errors,
                          options: _ctx.LOADING_TYPE_OPTIONS,
                          searchable: false,
                          selectBy: "name",
                          placeholder: "Тип погрузки",
                          disabled: _ctx.state.is_need_car
                        }, null, 8, ["value", "is-invalid", "validation-errors", "options", "disabled"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_the_input, {
                      value: _ctx.state.description,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.description) = $event)),
                      "is-invalid": _ctx.state_form$.description.$error,
                      "validation-errors": _ctx.state_form$.description.$errors,
                      placeholder: "Описание",
                      class: "mt-2",
                      disabled: _ctx.state.is_need_car
                    }, null, 8, ["value", "is-invalid", "validation-errors", "disabled"]),
                    _createVNode(_component_the_input, {
                      value: _ctx.state.temperature_mode,
                      "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.temperature_mode) = $event)),
                      placeholder: "Температурный режим",
                      class: "mt-2",
                      disabled: _ctx.state.is_need_car
                    }, null, 8, ["value", "disabled"]),
                    (_ctx.isAuto)
                      ? (_openBlock(), _createBlock(_component_the_select, {
                          key: 3,
                          value: _ctx.state.transport_type,
                          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.transport_type) = $event)),
                          placeholder: "Тип транспорта",
                          class: "mt-3",
                          options: _ctx.data_state.transport_types.list,
                          loading: _ctx.data_state.transport_types.is_loading,
                          searchable: false,
                          label: "title",
                          selectBy: "id",
                          disabled: Boolean(_ctx.state.is_need_car)
                        }, null, 8, ["value", "options", "loading", "disabled"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", _hoisted_8, [
                    _hoisted_9,
                    _createVNode(_component_radio_group, {
                      class: "small mt-2",
                      name: "payment_method",
                      value: _ctx.state.payment_method,
                      "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.payment_method) = $event)),
                      options: _ctx.PAYMENT_METHOD_OPTIONS
                    }, null, 8, ["value", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createVNode(_component_checkbox, {
                      value: _ctx.state.oversized_cargo,
                      "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.oversized_cargo) = $event)),
                      "return-integer": "",
                      label: "Негабарит"
                    }, null, 8, ["value"]),
                    _createVNode(_component_checkbox, {
                      value: _ctx.state.is_stacked,
                      "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.is_stacked) = $event)),
                      "return-integer": "",
                      label: "Штабелируемый груз"
                    }, null, 8, ["value"]),
                    _createVNode(_component_checkbox, {
                      value: _ctx.state.is_need_car,
                      "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.is_need_car) = $event)),
                      "return-integer": "",
                      label: "Без авто",
                      onChange: _ctx.onIsCarChange
                    }, null, 8, ["value", "onChange"]),
                    _createVNode(_component_checkbox, {
                      value: _ctx.state.is_dangerous,
                      "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.is_dangerous) = $event)),
                      "return-integer": "",
                      label: "Опасный груз",
                      onChange: _ctx.onIsDangerousChange
                    }, null, 8, ["value", "onChange"]),
                    (_ctx.state.is_dangerous)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                          _createVNode(_component_file_reader, {
                            class: "mt-2",
                            value: _ctx.state.invoice_files,
                            "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.invoice_files) = $event)),
                            placeholder: "Загрузите файл накладной",
                            disabled: _ctx.files_state.is_loading,
                            "is-invalid": _ctx.state_form$.invoice_files.$error,
                            "validation-errors": _ctx.state_form$.invoice_files.$errors,
                            accept: "all",
                            multiple: ""
                          }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]),
                          _createVNode(_component_file_reader, {
                            class: "mt-2",
                            value: _ctx.state.certificate_of_safety_files,
                            "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.certificate_of_safety_files) = $event)),
                            placeholder: "Загрузите сертификат безопасности",
                            disabled: _ctx.files_state.is_loading,
                            "is-invalid": _ctx.state_form$.certificate_of_safety_files.$error,
                            "validation-errors": _ctx.state_form$.certificate_of_safety_files.$errors,
                            accept: "all",
                            multiple: ""
                          }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"])
                        ]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_checkbox, {
                      label: "Застраховать груз",
                      value: _ctx.state.is_ensure,
                      "onUpdate:value": [
                        _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.is_ensure) = $event)),
                        _ctx.onChangeEnsure
                      ],
                      "return-integer": ""
                    }, null, 8, ["value", "onUpdate:value"]),
                    (_ctx.state.is_ensure)
                      ? (_openBlock(), _createBlock(_component_the_input, {
                          key: 1,
                          class: "mt-2",
                          placeholder: "Наименование груза",
                          value: _ctx.state.cargo_name,
                          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.cargo_name) = $event)),
                          "is-invalid": _ctx.state_form$.cargo_name.$error,
                          "validation-errors": _ctx.state_form$.cargo_name.$errors
                        }, null, 8, ["value", "is-invalid", "validation-errors"]))
                      : _createCommentVNode("", true),
                    (_ctx.state.is_ensure)
                      ? (_openBlock(), _createBlock(_component_the_input, {
                          key: 2,
                          class: "mt-2",
                          placeholder: "Объявленная стоимость",
                          value: _ctx.state.declared_price,
                          "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.declared_price) = $event)),
                          disabled: _ctx.state.is_need_car,
                          "is-invalid": _ctx.state_form$.declared_price.$error,
                          "validation-errors": _ctx.state_form$.declared_price.$errors
                        }, null, 8, ["value", "disabled", "is-invalid", "validation-errors"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createVNode(_component_the_button, {
                    type: "submit",
                    class: "primary text small",
                    disabled: _ctx.files_state.is_loading,
                    loading: _ctx.files_state.is_loading
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13,
                      _createTextVNode(" Подтвердить ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "loading"])
                ])
              ], 32))
            : (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  (_ctx.isAuto)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _hoisted_17,
                        _createElementVNode("p", null, [
                          (Boolean(_ctx.completed_state.car?.cubature))
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.completed_state.car?.cubature) + " м", 1),
                                _hoisted_18
                              ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(" Не указана ")
                              ], 64))
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isAuto)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _hoisted_20,
                        _createElementVNode("p", null, _toDisplayString(_ctx.completed_state.car?.load_capacity), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _hoisted_21,
                    _createElementVNode("p", null, _toDisplayString(_ctx.completed_state.car?.description), 1)
                  ]),
                  (_ctx.isAuto)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _hoisted_23,
                        _createElementVNode("p", null, _toDisplayString(_ctx.getTransportName || 'Не выбрано'), 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.isAuto)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                        _hoisted_25,
                        _createElementVNode("p", null, _toDisplayString(_ctx.completed_state.car.loading_type), 1)
                      ]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", null, [
                    _hoisted_26,
                    _createElementVNode("p", null, _toDisplayString(_ctx.completed_state.car.temperature_mode || 'Не указан'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_27,
                    _createElementVNode("p", null, _toDisplayString(_ctx.completed_state.car.declared_price || 'Не указана'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_28,
                    _createElementVNode("p", null, _toDisplayString(_ctx.completed_state.car.oversized_cargo ? 'Да' : 'Нет'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_29,
                    _createElementVNode("p", null, _toDisplayString(_ctx.completed_state.car.is_dangerous ? 'Да' : 'Нет'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_30,
                    _createElementVNode("p", null, _toDisplayString(_ctx.completed_state.car.is_stacked ? 'Да' : 'Нет'), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.completed_state.car.is_need_car ? 'Без авто' : 'С авто'), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_32, [
                  _createVNode(_component_the_button, {
                    class: "primary text small",
                    disabled: _ctx.disabled,
                    onClick: _ctx.updateCar
                  }, {
                    default: _withCtx(() => [
                      _hoisted_33,
                      _createTextVNode(" Редактировать ")
                    ]),
                    _: 1
                  }, 8, ["disabled", "onClick"])
                ])
              ]))
        ], 64))
      : _createCommentVNode("", true)
  ]))
}